// noinspection DuplicatedCode
import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "react-datepicker/dist/react-datepicker.css";

import { getPelatihanLaporan, pelatihanTransaksiSelector } from "./pelatihanTransaksiSlice";

import { Colors } from "../../../../assets/Colors";
import { Card } from "@material-tailwind/react";
import { HrdInputGenerator } from "../../../../components/form/HrdInputGenerator";
import { useForm } from "../../../../components/isRequired";
import { SearchBarSmallV2 } from "../../../../components/form/SearchBar";
import Skeltons from "../../../../components/loading/Skeltons";
import { downloadExcel } from "react-export-table-to-excel";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

const PAGE_SIZE = 10;
const fmtTgl = (v) => (v ? new Date(v).toLocaleDateString("id-ID") : "-");
const fmtNum = (v) => (v || v === 0 ? Number(v).toLocaleString("id-ID") : "-");

const PelatihanReport = ({}) => {
  let initialState = {
    bulan: new Date(),
    region: "L0001",
  };
  const validations = [];

  const { values, errors, touched, customHandler } = useForm(initialState, validations);

  const [searchQuery, setSearchQuery] = useState("");
  const [pageC, setPageC] = useState(1);

  const pelatihan = useSelector(pelatihanTransaksiSelector);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      getPelatihanLaporan({
        tahun: values.bulan.getFullYear().toString(),
        bulan: "",
        region: values.region,
      })
    );
  }, []);

  const allRows = useMemo(
    () => (Array.isArray(pelatihan.report) ? pelatihan.report : []),
    [pelatihan.report]
  );

  const filtered = useMemo(() => {
    const kw = searchQuery.trim().toLowerCase();
    if (!kw) return allRows;
    return allRows.filter((r) =>
      [r.Nik, r.NamaKaryawan, r.Jabatan, r.Golongan, r.LembagaPelatihan, r.TopikPelatihan].some(
        (v) => v && v.toString().toLowerCase().includes(kw)
      )
    );
  }, [allRows, searchQuery]);

  const totalPage = Math.max(1, Math.ceil(filtered.length / PAGE_SIZE));
  const safePage = Math.min(pageC, totalPage);
  const pageRows = useMemo(() => {
    const s = (safePage - 1) * PAGE_SIZE;
    return filtered.slice(s, s + PAGE_SIZE);
  }, [filtered, safePage]);

  useEffect(() => {
    setPageC(1);
  }, [searchQuery, pelatihan.report]);

  const filterApi = () => {
    dispatch(
      getPelatihanLaporan({
        tahun: values.bulan.getFullYear().toString(),
        bulan: (values.bulan.getMonth() + 1).toString(),
        region: values.region,
      })
    );
  };

  // ── Export (mengikuti hasil filter/search) ───────────────────
  const exportHeader = [
    "Nik", "Nama Karyawan", "Tanggal Masuk Kerja", "Jabatan", "Golongan", "Tanggal Mulai", "Tanggal Selesai",
    "Tempat Pelaksanaan", "Lembaga Pelatihan", "Topik Pelatihan", "Tujuan Pelatihan", "Biaya Pelatihan", "Biaya Tiket", "Total Biaya",
  ];
  const exportBody = () =>
    filtered.map((r) => [
      r.Nik || "", r.NamaKaryawan || "", fmtTgl(r.TglMasuk), r.Jabatan || "", r.Golongan || "",
      fmtTgl(r.TanggalMulai), fmtTgl(r.TanggalSelesai), r.TempatPelaksanaan || "", r.LembagaPelatihan || "",
      r.TopikPelatihan || "", r.TujuanPelatihan || "", r.BiayaPelatihan || "", r.BiayaTiket || "", r.TotalBiayaPelatihan || "",
    ]);
  const handleDownloadExcel = () => {
    downloadExcel({ fileName: "Report_Pelatihan", sheet: "data", tablePayload: { header: exportHeader, body: exportBody() } });
  };
  const handleDownloadPDF = () => {
    const doc = new jsPDF({ orientation: "landscape" });
    doc.setFontSize(13);
    doc.text("Report Pelatihan", 14, 14);
    autoTable(doc, { head: [exportHeader], body: exportBody(), startY: 20, styles: { fontSize: 6.5 }, headStyles: { fillColor: [30, 58, 95] } });
    doc.save("Report_Pelatihan.pdf");
  };

  const colHeader = [
    "Nik", "Nama Karyawan", "Jabatan", "Golongan", "Tanggal Mulai", "Tanggal Selesai",
    "Tempat", "Lembaga", "Topik", "Biaya Pelatihan", "Biaya Tiket", "Total Biaya",
  ];

  return (
    <>
      <div className="md:ml-64">
        <div style={{ background: Colors.primary }} className="pt-14 pb-16 px-3 md:px-8 h-auto">
          <div className="container mx-auto max-w-full">
            <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4"></div>
          </div>
        </div>
        <div className="px-3 md:px-8 h-auto -mt-32">
          <div className="container mx-auto max-w-full">
            <div className="grid grid-cols-1 px-4">
              <Card>
                <div className="flex flex-row flex-wrap items-start justify-start w-full px-4 py-3 gap-4">
                  <div className="w-full sm:w-1/4">
                    <HrdInputGenerator type={"region"} name={"region"} title={"Region"} value={values} required={true}
                      onChange={customHandler} touched={touched} errors={errors} size={"full"} />
                  </div>
                  <div className="w-full sm:w-1/4">
                    <HrdInputGenerator type={"tahun"} name={"bulan"} title={"Tahun"} value={values} required={true}
                      onChange={customHandler} touched={touched} errors={errors} size={"full"} />
                  </div>
                  <div>
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">&nbsp;</label>
                    <button type="button" onClick={filterApi}
                      className="h-[42px] text-main-100 hover:text-white border border-main-100 hover:bg-main-100 font-medium rounded-lg text-sm px-7 text-center">
                      Buka
                    </button>
                  </div>
                </div>

                {pelatihan.isGetReport === false && allRows.length === 0 ? (
                  <div className="w-full pt-0"><Skeltons /></div>
                ) : (
                  <>
                    <div className="flex w-full justify-between px-4 pt-2 flex-col sm:flex-row gap-2">
                      <div className="flex flex-row gap-2 flex-wrap">
                        <button onClick={handleDownloadExcel}
                          className="flex items-center justify-center my-1 sm:my-0 bg-white text-gray-800 font-semibold py-2 px-4 border border-green-600 hover:bg-green-600 hover:text-white rounded shadow">
                          Download Excel
                        </button>
                        <button onClick={handleDownloadPDF}
                          className="flex items-center justify-center my-1 sm:my-0 bg-white text-gray-800 font-semibold py-2 px-4 border border-red-400 hover:bg-red-400 hover:text-white rounded shadow">
                          Download PDF
                        </button>
                      </div>
                      <div className="w-full sm:w-72">
                        <SearchBarSmallV2 text={"Cari Nama Karyawan"} value={searchQuery} funcs={(e) => setSearchQuery(e.target.value)} />
                      </div>
                    </div>

                    <div className="overflow-x-auto px-4 pt-2">
                      <table className="table-auto w-full text-sm text-left text-gray-500 mt-4">
                        <thead className="text-xs text-orange-600 uppercase bg-gray-50">
                          <tr>{colHeader.map((h, i) => <th key={i} scope="col" className="py-3 px-6 whitespace-nowrap">{h}</th>)}</tr>
                        </thead>
                        <tbody>
                          {pageRows.length === 0 ? (
                            <tr><td colSpan={colHeader.length} className="text-center py-8 text-gray-400">
                              {searchQuery ? `Tidak ada data untuk "${searchQuery}"` : "Tidak ada data"}
                            </td></tr>
                          ) : (
                            pageRows.map((row, id) => (
                              <tr key={row.Nik + "-" + id} className={id % 2 === 0 ? "bg-gray-50 border-b" : "bg-white border-b"}>
                                <td className="py-4 px-6 whitespace-nowrap font-mono text-xs">{row.Nik}</td>
                                <td className="py-4 px-6">{row.NamaKaryawan || "-"}</td>
                                <td className="py-4 px-6">{row.Jabatan || "-"}</td>
                                <td className="py-4 px-6">{row.Golongan || "-"}</td>
                                <td className="py-4 px-6 whitespace-nowrap">{fmtTgl(row.TanggalMulai)}</td>
                                <td className="py-4 px-6 whitespace-nowrap">{fmtTgl(row.TanggalSelesai)}</td>
                                <td className="py-4 px-6">{row.TempatPelaksanaan || "-"}</td>
                                <td className="py-4 px-6">{row.LembagaPelatihan || "-"}</td>
                                <td className="py-4 px-6">{row.TopikPelatihan || "-"}</td>
                                <td className="py-4 px-6 text-right whitespace-nowrap">{fmtNum(row.BiayaPelatihan)}</td>
                                <td className="py-4 px-6 text-right whitespace-nowrap">{fmtNum(row.BiayaTiket)}</td>
                                <td className="py-4 px-6 text-right whitespace-nowrap">{fmtNum(row.TotalBiayaPelatihan)}</td>
                              </tr>
                            ))
                          )}
                        </tbody>
                      </table>
                    </div>

                    <div className="flex flex-row justify-between items-center gap-4 px-4 py-4 text-sm text-gray-600">
                      <span>{filtered.length} data</span>
                      <div className="flex items-center gap-4">
                        <button onClick={() => setPageC((p) => Math.max(1, p - 1))} disabled={safePage <= 1}
                          className="border px-4 py-1 rounded disabled:opacity-50 hover:bg-gray-100">Prev</button>
                        <span>Page {safePage} / {totalPage}</span>
                        <button onClick={() => setPageC((p) => Math.min(totalPage, p + 1))} disabled={safePage >= totalPage}
                          className="border px-4 py-1 rounded disabled:opacity-50 hover:bg-gray-100">Next</button>
                      </div>
                    </div>
                  </>
                )}
              </Card>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PelatihanReport;
